module.exports = __webpack_public_path__ + "static/assets/85ba8d8493db6a87cd9b0010cfe09400.png";